<template>
    <form v-if="!connectRequest" @submit.prevent="submitRequest">
        <h1>Anslut ny butik</h1>

        <p>
            <router-link to="" class="button">Tillbaka</router-link>
        </p>

        <p>
            <label for="store_new_tradera_user">Användarnamn på Tradera</label>
            <input type="text" v-model="traderaUser" id="store_new_tradera_user" required />
        </p>

        <p>
            <button type="submit">Fortsätt</button>
        </p>
    </form>
    <form v-else @submit.prevent="submitLogin">
        <p>
            Ett inloggningsfönster till Tradera har öppnats.
            Om din webbläsare har en popup-blockerare kan du behöva göra ett undantag
            för denna webbplats.
        </p>
        <p>
            När du loggat in på Tradera tryck på Slutför nedan.
        </p>
        <p>
            <button type="submit">Slutför</button>
        </p>
    </form>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'storeNew',
    data: function () {
        return {
            traderaUser: null
        }
    },
    computed: {
        ...mapState('traderaStoreConnectRequest', {
            tradera: state => state.tradera,
            connectRequest: state => state.connectRequest
        })
    },
    methods: {
        submitRequest() {
            this.$store.dispatch('traderaStoreConnectRequest/beginConnect', this.traderaUser)
                .then(() => {
                    window.open(`https://api.tradera.com/tokenlogin.aspx?appId=${this.tradera.app_id}&pkey=${this.tradera.public_key}&skey=${this.connectRequest.token}`);
                })
            ;
        },
        submitLogin() {
            this.$store.dispatch('traderaStoreConnectRequest/finalizeConnect')
                .then(() => {
                    this.$router.push('/');
                })
            ;
        }
    }
}
</script>
